import React from 'react';
// material
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
// entities
import { MessageGroup as MessageGroupEntity, Message } from '../../../entities/notification';
// components
import MessageRow from './MessageRow';

interface MessageRowEntity {
  title: string;
  date: string;
  message: string;
}

interface MessageGroupProps {
  messageGroup: MessageGroupEntity;
  messages: Message[];
}

const MessageGroup: React.FC<MessageGroupProps> = (props) => {
  const classes = useStyles();

  return (
    <div>
      <div style={{marginBottom: 10}}>
        <div className={classes.title}>History</div>
      </div>
      {props.messages.map((message: Message, index: number) => (
        <div key={`message-${index}`} style={{marginBottom: 10}}>
          <MessageRow message={message} messageGroug={props.messageGroup} />
        </div>
      ))}
    </div>
  );

}

export default MessageGroup;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      padding: 10
    },
    title: {
      textAlign: 'left',
      textWeight: 'bold'
    },
    status: {
      color: '#29C7E2'
    }
  })
);


// WEBPACK FOOTER //
// ./src/pages/campaign/components/MessageGroup.tsx